import Dashboard from '@/agilis/components/Dashboard/Dashboard.vue'
import TrackerDashboardTable from '@/applications/scrum/components/TrackerDashboard/TrackerDashboardTable/TrackerDashboardTable.vue'
import dataMixin from '@/agilis/components/Dashboard/mixin/dataMixin'

export default {
  name: 'TrackerDashboard',
  mixins: [
    dataMixin
  ],

  props: {
    api: String,
    configuration: Object
  },

  components: {
    Dashboard,
    TrackerDashboardTable
  },

  methods: {
    queryId (metric) {
      return metric.query || 'search'
    },

    queryUrl (metric) {
      const queryId = this.queryId(metric)
      return queryId === 'search' ? this.api : this.$axios.agilisUrlQuery(this.applicationId, queryId)
    }
  }
}
